import * as React from 'react';

const Money24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.5 5A1.5 1.5 0 0 0 1 6.5v11A1.5 1.5 0 0 0 2.5 19h19a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 21.5 5h-19Zm0 1.5h2.743A4.5 4.5 0 0 1 2.5 9.243V6.5Zm14.69 0H6.81a6 6 0 0 1-4.31 4.31v2.38a6.01 6.01 0 0 1 2.743 1.567A5.999 5.999 0 0 1 6.809 17.5H17.19a6.007 6.007 0 0 1 3.514-4.043c.26-.108.525-.197.796-.267v-2.38a6.007 6.007 0 0 1-4.043-3.514 6.01 6.01 0 0 1-.267-.796Zm4.31 2.743V6.5h-2.743A4.502 4.502 0 0 0 21.5 9.243ZM2.5 17.5v-2.743A4.502 4.502 0 0 1 5.243 17.5H2.5Zm16.343-.222c-.03.073-.06.147-.086.222H21.5v-2.743a4.503 4.503 0 0 0-2.657 2.52Z",
    clipRule: "evenodd"
  }
));
Money24.Size = 24;
Money24.Title = "Money";

export { Money24 as default };
